import "./styles.less";

import React, { useState } from "react";
import { useOrder } from "./Order.hook";
import { useSearchResultsFilters } from "../../../ViewFragments/SearchResults/Sider/Filters/SearchResultsFilters.hook";
// import { useGoogleAnalytics } from "shared-components/GlobalHooks/web/GoogleAnalytics.hook";
import { OrderIcon } from "shared-components/Components/CustomIcons/OrderIcon/web";
import { Button } from "shared-components/Components/Buttons/web";
import { useClickAway } from "shared-components/GlobalHooks/useClickAway";


export const Order = () => {
	const { changeFiltersAndUpdateURL } = useSearchResultsFilters();
	const {
		loading,
		data: { options, customKey, valueKey, value, onChange },
		error,
		show,
	} = useOrder({ filterChanged: changeFiltersAndUpdateURL });

	// const GA = useGoogleAnalytics();

	const [open, setOpen] = useState<boolean>(false)
	const dropdownRef = useClickAway(() => { setOpen(false) })

	if (!show) return null;
	if (error) return <div>{"error"}</div>;
	if (loading) return null

	const handleChange = (value) => {
		// GA.Event({
		// 	category: 'user_event',
		// 	action: 'search_change_sort',
		// 	label: value?.text ?? ''
		// })
		onChange(value)
		setOpen(false)
	}

	const getSelectedText = (opt, val) => {
		const res = opt.find(o => o[customKey] == val)
		return res ? res.text : "Popularidad"
	}

	return (
		<div className="order-filter" ref={dropdownRef}>
			<Button type="secondary" className="order-filter-btn"  onClick={(e:any) => {
				e.preventDefault()
				e.stopPropagation()
				setOpen(!open)
			} } >
				<OrderIcon />
				
				<span className="order-filter-btn-text">
					{getSelectedText(options, value)}
				</span>
				
				{open &&
					<div className="dropdown" >
						{options?.map(opt => 
							<span key={"key_"+opt[customKey] }
								onClick={() => {handleChange(opt)}}
								className={opt[customKey]==value ? 'selected' : ''}
							>
								{opt[valueKey]}
							</span>
						)}
					</div>
				}
			</Button>
		</div>
	);
};
